import './src/styles/global.css'

export const onClientEntry = () => {
  const language = window.localStorage.getItem('gatsby-i18next-language') || 'ar'
  const dir = language === 'ar' ? 'rtl' : 'ltr'
  document.documentElement.setAttribute('dir', dir)
  document.documentElement.setAttribute('lang', language)
}

export const onRouteUpdate = ({ location }) => {
  // Ensure hash is always present
  if (!location.hash) {
    window.history.replaceState(null, '', `${location.pathname}#home`)
  }
}

// Handle initial page load
export const onInitialClientRender = () => {
  if (typeof window !== 'undefined' && !window.location.hash) {
    window.history.replaceState(null, '', `${window.location.pathname}#home`)
  }
}